<template>
    <div class="h-full relative">
        <div
            class="absolute inset-0 z-20 bg-gray-500 bg-opacity-90 transition-opacity"
            v-if="!step7Complete"
        ></div>
        <div class="absolute inset-0 z-20" v-if="!step7Complete">
            <div class="absolute inset-0 z-20 w-100 overflow-y-auto">
                <div
                    class="flex min-h-full items-center justify-center p-4 text-center sm:p-0"
                >
                    <div
                        class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6"
                    >
                        <div>
                            <div
                                class="mx-auto flex items-center justify-center"
                            >
                                <span class="fa-stack relative z-20 fa-lg">
                                    <i
                                        class="fa-solid fa-circle fa-stack-2x text-red-100"
                                    ></i>
                                    <i
                                        class="fa-regular fa-exclamation fa-stack-1x fa-inverse text-red-700"
                                    ></i>
                                </span>
                            </div>
                            <div class="mt-3 text-center sm:mt-5">
                                <h3
                                    class="text-base font-semibold leading-6 text-gray-900"
                                    id="modal-title"
                                >
                                    Go Back to the Previous Step
                                </h3>
                                <div class="mt-2">
                                    <p class="text-sm text-gray-500">
                                        You must complete the previous step
                                        before continuing.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="absolute inset-0mai z-10" v-if="!step7Complete"></div>
        <img
            src="/images/companionpass/companionpass_success.png"
            class="mx-auto mb-5 lg:mb-10"
            alt="My10X"
        />
    </div>
</template>
<script>
import { mapState, mapActions } from 'pinia';
import { useCompanionPassStore } from '@/store/companionpass';

export default {
    name: 'StepEight',
    props: {},
    components: {},
    data: () => ({}),
    computed: {
        ...mapState(useCompanionPassStore, ['completeSteps']),
        stepComplete() {
            return 8 in this.completeSteps ? true : false;
        },
        step7Complete() {
            return 7 in this.completeSteps ? true : false;
        },
        cdnUrl() {
            return window.cdnUrl;
        },
    },
    methods: {
        ...mapActions(useCompanionPassStore, ['getStep', 'getStepContent']),
    },
    mounted() {},
};
</script>
